import EmployeeCalendar from "./EmployeeCalendar/EmployeeCalendar.vue";
import PatientCalendar from "./PatientCalendar/PatientCalendar.vue";
import UnassignedPatientVisits from "./UnassignedPatientVisits/UnassignedPatientVisits.vue";
import FrequencyWatch from "./FrequencyWatch/FrequencyWatch.vue";
import HuvSfvStatusReport from "./HuvSfvStatusReport/HuvSfvStatusReport.vue";

const routes: any = [
    {
        path: "/axxess-central/schedule-center/employee",
        component: EmployeeCalendar,
        name: "employee",
        meta: {
            menuName: "Employee Calendar",
            navItem: "tabEmployee",
            showAxxessCentral: true
        }
    },
    {
        path: "/axxess-central/schedule-center/patient",
        component: PatientCalendar,
        name: "patient",
        meta: {
            menuName: "Patient Calendar",
            navItem: "tabPatient",
            showAxxessCentral: true
        }
    },
    {
        path: "/axxess-central/schedule-center/unassigned-patient-visits",
        component: UnassignedPatientVisits,
        name: "unassigned patient visits",
        meta: {
            menuName: "Unassigned Patient Visits",
            navItem: "tabUnassignedPatientVisit",
            showIfNotOnlyHH: true,
            showAxxessCentral: true
        }
    },
    {
        path: "/axxess-central/schedule-center/frequency-watch",
        component: FrequencyWatch,
        name: "frequency-watch",
        meta: {
            menuName: "Frequency Watch",
            navItem: "tabFrequencyWatch",
            showFrequencyWatch: true
        }
    },
    {
        path: "/axxess-central/schedule-center/hul-sfv-status-report",
        component: HuvSfvStatusReport,
        name: "HUV and SFV Status Report",
        meta: {
            menuName: "HUV and SFV Status Report",
            navItem: "tabHUVandSFVStatusReport",
            showHopeReport: true
        }
    }
];

export default routes;
